import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, User, Users, MessageSquare, Calendar, Sparkles, Settings, LogOut, Megaphone } from "lucide-react";
import { useMemberAuth } from "../context/MemberAuthContext";

const NAV = [
  { to: "/member", label: "Home", icon: Home, end: true },
  { to: "/member/updates", label: "Network Updates", icon: Megaphone },
  { to: "/member/profile", label: "My Profile", icon: User },
  { to: "/member/directory", label: "Directory", icon: Users },
  { to: "/member/messages", label: "Messages", icon: MessageSquare },
  { to: "/member/events", label: "Events", icon: Calendar },
  { to: "/member/opportunities", label: "Opportunities", icon: Sparkles },
  { to: "/member/account", label: "Account", icon: Settings },
];

const Avatar = ({ src, name, size = 36 }) => {
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return src ? (
    <img src={src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`} alt="" className="rounded-full object-cover" style={{ width: size, height: size }} />
  ) : (
    <div className="rounded-full flex items-center justify-center font-medium" style={{ width: size, height: size, background: '#0f3d2e', color: '#f4efe4', fontSize: size * 0.42 }}>{initial}</div>
  );
};

export { Avatar };

const MemberLayout = ({ children }) => {
  const { member, unread, logout } = useMemberAuth();
  const nav = useNavigate();
  if (!member) return null;

  return (
    <div className="min-h-screen" style={{ background: '#f4efe4' }}>
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-6 grid lg:grid-cols-[260px_1fr] gap-6">
        {/* Sidebar */}
        <aside className="lg:sticky lg:top-6 self-start">
          <div className="rounded-lg p-5 mb-4" style={{ background: '#fbf8ef' }}>
            <div className="flex items-center gap-3">
              <Avatar src={member.avatar_url} name={member.display_name} size={44} />
              <div className="min-w-0">
                <div className="font-medium text-[14px] truncate">{member.display_name || 'Member'}</div>
                <div className="text-[12px] text-[#0d2a20]/60 truncate">{member.headline || 'Vemoye Network'}</div>
              </div>
            </div>
          </div>
          <nav className="rounded-lg p-2" style={{ background: '#fbf8ef' }}>
            {NAV.map(n => {
              const Ic = n.icon;
              return (
                <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `flex items-center justify-between gap-3 px-3 py-2 rounded-md text-[14px] transition-colors ${isActive ? 'bg-[#0f3d2e] text-[#f4efe4]' : 'text-[#0d2a20] hover:bg-[#ece5d3]'}`}>
                  <span className="flex items-center gap-3"><Ic size={16} /> {n.label}</span>
                  {n.to === "/member/messages" && unread > 0 && (
                    <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full" style={{ background: '#e0684d', color: 'white' }}>{unread}</span>
                  )}
                </NavLink>
              );
            })}
            <button onClick={() => { logout(); nav('/'); }} className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-[14px] text-[#0d2a20]/80 hover:bg-[#ece5d3]"><LogOut size={16} /> Sign out</button>
          </nav>
        </aside>

        <main className="min-w-0">{children}</main>
      </div>
    </div>
  );
};

export default MemberLayout;
